import { Stack, useTheme } from "@mui/material";
import { User } from "lucide-react";
import { useClientQuery } from "web_myplann/Api/Client/useClientQuery";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DataRowCard } from "web_myplann/Shared/Components/DataRowCard";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

export const PersonalDataAndAccountsPage = () => {
	const theme = useTheme();
	const { t } = useResource();

	const { data: userData } = useClientQuery();

	return (
		<MyPlannLayout
			disableContentPadding
			topBar={
				<NavigationHeader
					title={t(Resources.PersonalDataAndAccounts.title)}
					defaultRoute={Routing.Dashboard.path()}
				/>
			}
		>
			<Stack p={1.6}>
				<DataRowCard
					icon={<User color={theme.palette.deprecated.grey[700]} />}
					label={t(Resources.PersonalDataAndAccounts.PersonalData.title)}
					noDivider
					items={[
						{
							label: t(Resources.PersonalDataAndAccounts.PersonalData.Name),
							value: userData?.data?.firstName,
						},
						{
							label: t(Resources.PersonalDataAndAccounts.PersonalData.Surname),
							value: userData?.data?.lastName,
						},
						{
							label: t(
								Resources.PersonalDataAndAccounts.PersonalData.BirthNumber,
							),
							value: userData?.data?.identificationNumber,
						},
						{
							label: t(
								Resources.PersonalDataAndAccounts.PersonalData.BirthDate,
							),
							value: dateFormatter(userData?.data?.bornDate),
						},
						{
							label: t(
								Resources.PersonalDataAndAccounts.PersonalData.BirthPlace,
							),
							value: userData?.data?.bornPlace,
						},
						{
							label: t(
								Resources.PersonalDataAndAccounts.PersonalData.MaritalStatus,
							),
							value: userData?.data?.maritalStatus,
						},
						{
							label: t(
								Resources.PersonalDataAndAccounts.PersonalData.HealthInsurance,
							),
							value: userData?.data?.healthInsurance,
						},
					]}
				/>
			</Stack>
		</MyPlannLayout>
	);
};
